import { EntityState, StoreConfig } from '@datorama/akita';
import { Injectable, OnDestroy } from '@angular/core';
import { EventInput, DateRangeInput } from '@fullcalendar/core';
import { AbstractUiEntityStore } from 'projects/app-misc/src/app/modules/data/abstract-ui-entity.store';

export interface VacationEventsState extends EntityState<EventInput, number> {
    ui: {
        dateRange: DateRangeInput
        filtered: number[]
    };

}

@Injectable()
@StoreConfig({ name: 'eventsInput' })
export class VacationEventsStore extends AbstractUiEntityStore<VacationEventsState> {
    constructor(
    ) {
        super({
            ui: {
                filtered: [],
                dateRange: {
                    start: null,
                    end: null
                }
            }
        })
    }

    updateDateRange(dateStart: Date, dateEnd: Date) {
        this.updateUi({
            dateRange: {
                start: dateStart,
                end: dateEnd
            }
        })
    }

    updateFiltered(filtered: number[]) {
        this.updateUi({
            filtered
        })
    }


}